import * as React from "react";
import getConfig from "next/config";
import { AppointmentUtils, AppointmentSlotsProvider, CancelAppointmentRoutingProvider, cancelAppointmentRouteMap, cancelAppointmentRoutingErrorHandler } from "@grandvisionhq/appointments";
import { useBloomreachPageRoutes, CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { extractCurrentRoute } from "@grandvisionhq/utils";
const { publicRuntimeConfig } = getConfig();
const selfUrl = publicRuntimeConfig?.selfUrl || "";
const Page = ({
  currentRoute,
  queryParams,
  slots,
  cancellationReasons
}) => {
  const { id: appointmentId, appointmentToken } = queryParams;
  const { routes } = useBloomreachPageRoutes();
  const initialRoutingState = {
    basePath: routes["appointment-cancel"] ?? "",
    queryParams,
    currentRoute
  };
  const initialState = {
    bookAppointmentUrl: routes["appointment-book"] ?? "",
    token: AppointmentUtils.fromArrayToString(appointmentToken),
    appointmentId: AppointmentUtils.fromArrayToString(appointmentId),
    cancellationReasons
  };
  return /* @__PURE__ */ React.createElement(
    AppointmentSlotsProvider,
    {
      slots: {
        confirmationTime: slots?.confirmationPage?.time
      }
    },
    /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/top-container" }),
    /* @__PURE__ */ React.createElement(
      CancelAppointmentRoutingProvider,
      {
        routeMap: cancelAppointmentRouteMap,
        initialRoutingState,
        initialState
      }
    ),
    /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" })
  );
};
Page.getInitialProps = ({ query: queryParams, asPath = "", req, res, localRouteFormatters }) => {
  const locale = req?.locale.toString();
  const currentRoute = extractCurrentRoute(asPath, locale);
  if (!(currentRoute in cancelAppointmentRouteMap)) {
    console.error(`Invalid cancel appointment route: ${currentRoute}`, {
      asPath,
      currentRoute,
      availableRoutes: Object.keys(cancelAppointmentRouteMap)
    });
    const errorMessage = "INVALID_ROUTE";
    const action = cancelAppointmentRoutingErrorHandler(
      errorMessage,
      selfUrl,
      asPath,
      currentRoute,
      queryParams,
      publicRuntimeConfig,
      localRouteFormatters?.["me.profile"]?.({ route: "me.profile" }) ?? void 0
    );
    if (action.type === "redirect") {
      res?.writeHead(302, {
        Location: action.url
      });
      res?.end();
    }
    return {
      statusCode: 400,
      currentRoute,
      queryParams
    };
  }
  try {
    CancelAppointmentRoutingProvider?.getServerSideProps(
      currentRoute,
      cancelAppointmentRouteMap,
      locale
    );
  } catch (error) {
    console.error("Routing error", error, {
      queryParams,
      currentRoute,
      asPath,
      availableRoutes: Object.keys(cancelAppointmentRouteMap),
      errorMessage: error?.message
    });
    const errorMessage = error?.message ?? "UNKNOWN_ERROR";
    const action = cancelAppointmentRoutingErrorHandler(
      errorMessage,
      selfUrl,
      asPath,
      currentRoute,
      queryParams,
      publicRuntimeConfig,
      localRouteFormatters?.["me.profile"]?.({ route: "me.profile" }) ?? void 0
    );
    if (action.type === "redirect") {
      res?.writeHead(302, {
        Location: action.url
      });
      res?.end();
    }
    return {
      statusCode: 400,
      currentRoute,
      queryParams
    };
  }
  return {
    queryParams,
    currentRoute
  };
};
export {
  Page
};
//# sourceMappingURL=cancel-appointment.js.map
